export enum StatusFilter {
  All = '',
  Active = 'true',
  Inactive = 'false'
}